import clsx from 'clsx';
import React from 'react';

import FontLoader from '@/components/global/FontLoader';

import styles from './ProoferCard.module.scss';

interface Props {
  fontName: string;
  s3Path: string;
  setSelectedFontFamily: (value: string) => void;
}

const ProoferCard: React.FC<Props> = ({ fontName, s3Path, setSelectedFontFamily, children }) => {
  const onSelectFontFamily = (e) => setSelectedFontFamily(e.currentTarget.value);

  return (
    <React.Fragment key={fontName}>
      <FontLoader fullPath={!s3Path?.includes('https://')} fontName={fontName} s3Path={s3Path} />
      <input
        className={styles.radio}
        type="radio"
        id={fontName}
        name="fontFamily"
        value={fontName}
        onChange={onSelectFontFamily}
      />
      <label htmlFor={fontName} className={clsx(styles.card)}>
        {children}
      </label>
    </React.Fragment>
  );
};

export default ProoferCard;
